// Auto-rotation removed for CPU performance - manual navigation added instead
import { useState, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { authLabels } from "@/i18n";

const NEWS_IMAGES = [
  "/assets/auth_a.jpg",
  "/assets/auth_b.jpg",
];

const NewsSection = () => {
  const { language } = useLanguage();
  const labels = useMemo(() => authLabels(language), [language]);
  const newsItems = useMemo(
    () =>
      (labels.news?.items || []).map((item: { title: string; text: string }, i: number) => ({
        ...item,
        image: NEWS_IMAGES[i % NEWS_IMAGES.length],
      })),
    [labels.news?.items]
  );
  const [currentNews, setCurrentNews] = useState(0);

  const handlePrev = () => {
    setCurrentNews((prev) => (prev === 0 ? Math.max(0, newsItems.length - 1) : prev - 1));
  };

  const handleNext = () => {
    setCurrentNews((prev) => (newsItems.length ? (prev + 1) % newsItems.length : 0));
  };

  const hasNews = newsItems.length > 0;
  const currentItem = hasNews ? newsItems[currentNews] : null;

  return (
    <div className="w-1/2 bg-black relative overflow-hidden h-[400px] rounded-lg shadow-xl">
      <div className="absolute inset-0" key={currentNews}>
        <img
          src={currentItem?.image || NEWS_IMAGES[0]}
          alt={currentItem?.title || ""}
          className="w-full h-full object-cover opacity-50 rounded-md"
        />
        {hasNews && currentItem && (
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/70 to-transparent">
            <h2 className="text-xl font-bold text-white mb-2">{currentItem.title}</h2>
            <p className="text-gray-300">{currentItem.text}</p>
          </div>
        )}
      </div>
      
      {hasNews && newsItems.length > 1 && (
        <div className="absolute inset-0 flex justify-between items-center px-2 pointer-events-none">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full bg-black/30 hover:bg-black/50 pointer-events-auto"
          onClick={handlePrev}
        >
          <ChevronLeft className="h-4 w-4 text-white" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full bg-black/30 hover:bg-black/50 pointer-events-auto"
          onClick={handleNext}
        >
          <ChevronRight className="h-4 w-4 text-white" />
        </Button>
      </div>
      )}

      <div className="absolute top-6 left-6 text-white">
        <h1 className="text-3xl font-bold mb-3">
          {labels.news?.welcomeTitleLine1 || "Välkommen till"}
          <br />
          {labels.news?.welcomeTitleLine2 || "BILENIA Auktioner"}
        </h1>
        <p className="text-lg text-gray-300 max-w-md">
          {labels.news?.welcomeText ||
            "Din destination för exklusiva bilauktioner. Upptäck ett brett utbud av fordon och börja din resa med oss idag."}
        </p>
      </div>
    </div>
  );
};
export default NewsSection;
